import { render, staticRenderFns } from "./ProjectRiskManageList.vue?vue&type=template&id=6f2c2e94&"
import script from "./ProjectRiskManageList.vue?vue&type=script&lang=js&"
export * from "./ProjectRiskManageList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRiskManageList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports